<template>
  <div class="right_tabs">
    <el-tabs
    class="header_tabs"
    :value="current"
    :closable="true"
    type="card"
    @edit="handleTabsEdit"
    @tab-click="handleClick"
    >
    <el-tab-pane
      :key="item.name"
      v-for="(item, index) in opened"
      :label="item.meta.title"
      :name="item.name">
    </el-tab-pane>
    </el-tabs>
    <div class="tabs_action">
      <el-dropdown
        size="default"
        split-button
        @click="closeAll"
        @command="command => handleControlItemClick(command)">
        <el-dropdown-menu slot="dropdown">
          <!-- <el-dropdown-item command="left">
      			<i class="iconfont">&#xe625;</i>
            <d2-icon name="arrow-left" class="d2-mr-10"/>
            关闭左侧
          </el-dropdown-item>
          <el-dropdown-item command="right">
            <d2-icon name="arrow-right" class="d2-mr-10"/>
            关闭右侧
          </el-dropdown-item> -->
          <el-dropdown-item command="other">
            关闭其它
          </el-dropdown-item>
          <el-dropdown-item command="all">
            全部关闭
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </div>
</template>

<script>
import { mapState,mapActions } from 'vuex';
import eventBus from './../../main.js';

export default{
  props:{
  },
  data() {
    return {
    }
  },
  created(){
    this.init();
    this.$keepAliveManager.tabItemObject=this;      
    //this.open();
  },
  updated(){

  },
  watch:{
  	//监听路由变化
    $route:{
      handler:function(to, from){
        this.setTabPool();
        //this.open();
      },
      // 深度观察监听
      deep: true
    }
  },
  computed:{
    ...mapState('pages',[
      "opened",
      "current"
    ])
  },
  methods: {
    ...mapActions('pages',[
      "open",
      "init",
      "close",
      "closeOther",
      "closeAll",
      "skipRoutePage"
    ]),
    /* TAB选项卡 */
    setTabPool(){
    },
    /**
     * @description 接收点击关闭控制上选项的事件
     */
    handleControlItemClick (command, tagName = null) {
      switch (command) {
        case 'left':
          //this.closeLeft(params)
          break
        case 'right':
          //this.closeRight(params)
          break
        case 'other':
          //this.closeOther()
          this.closeOtherTabItem();
          break
        case 'all':
         // this.closeAll()
          this.closeAllTabItem();
          break
        default:
          this.$message.error('无效的操作')
          break
      }
    },
    /**
     * 关闭所有选项卡
     */
    closeAllTabItem(){
      //debugger;
      //let keepAlive=this.$keepAliveManager.keepAlive;
      this.$keepAliveManager.clearAllCache();
      this.closeAll();
    },
    /**
     * 关闭
     */
    closeOtherTabItem(){
       this.$keepAliveManager.clearOtherCache();
       this.closeOther();
    },
    /**
     * @description 右键菜单功能点击
     */
    handleContextmenu (event) {
      let target = event.target
      // 解决 https://github.com/d2-projects/d2-admin/issues/54
      let flag = false
      if (target.className.indexOf('el-tabs__item') > -1) flag = true
      else if (target.parentNode.className.indexOf('el-tabs__item') > -1) {
        target = target.parentNode
        flag = true
      }
      if (flag) {
        event.preventDefault()
        event.stopPropagation()
        this.contentmenuX = event.clientX
        this.contentmenuY = event.clientY
        this.tagName = target.getAttribute('aria-controls').slice(5)
        this.contextmenuFlag = true
      }
    },
    /**
     * @description 接收点击 tab 标签的事件
     */
    handleClick (tab, event) {
      // 找到点击的页面在 tag 列表里是哪个
      const page = this.opened.find(page => page.name === tab.name)
      const { name,params,query } = page;
      if(page){
        this.$router.push({"name":name,"params":params});
        if(page.meta){
          if(page.meta.clearCache!=undefined){
             page.meta.clearCache=false;//关闭缓存清除
          }         
        }
      }
      this.$bus.emit('onClickTabPage', name);
    },

    /**
     * 从当前页跳转目标路由页
     */
    backTargetTab(currentTabName,routObj){
      //判断传入的是否为当前激活页
      if(this.current!=currentTabName){
         return;
      }
      //移除当前待关闭的页tab
      const page = this.opened.find(page => page.name === currentTabName)
      if(page){
          //关闭当前tab
          const index = this.opened.findIndex(page => page.name === currentTabName)
          if (index >= 0) {
            this.opened.splice(index, 1)
          }
          //离开关闭当前页缓存 
          if(page.meta){
              page.meta.clearCache=true;
          }          
      }
      //调转到目录tab项
      this.$router.push(routObj);
    },

    /**
     * @description 点击 tab 上的删除按钮触发这里 首页的删除按钮已经隐藏 因此这里不用判断是 index
     */
    handleTabsEdit (tagName, action) {
      const page = this.opened.find(page => page.name === tagName)   
      //重新更新左侧菜单索引
      this.$emit('getLeftMenuIndex');
      if(action === 'remove'){//删除
        if(page.meta){
           if(page.meta.clearCache!=undefined){
             page.meta.clearCache=true;//清空组件缓存
           }          
        }
        //this.$bus.emit('onRemoveTabPage', tagName);
        this.close({tagName});
      }
    },

  }
}
</script>

<style>
.header_tabs .el-tabs__nav .el-tabs__item:nth-child(1) span{display: none;}
.right_tabs .tabs_action{position: absolute;right: 0;top: 0;}
.right_tabs .tabs_action .el-button-group>.el-button:not(:last-child){display:none;}
.right_tabs .el-button{padding:10px 20px;}
</style>
